import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Helmet } from 'react-helmet-async';
import { BASE_URL } from '../../Utils/base_url';
import { blockInvalidChar } from "../../components/blockInvalidChar";
import { AjouteCarte, AfficheCarte, AfficheCarteRestaurant, AfficheBoisson } from '../../Api/RestaurantApi/CarteApi';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import { PhotoProvider, PhotoView } from 'react-photo-view';


// Visualiser
import Pagination from '@material-ui/lab/Pagination';
import Slider from "react-slick";
import Image6 from "../../Image/une (1).png";
import Image7 from "../../Image/une (2).jpg";
import Image10 from "../../Image/une (5).png";
import Image11 from "../../Image/une (4).jpg";
import Chef from "../../Image/chef.png";
import EntrerIcon from "../../Image/entrer.png";
import PlatIcon from "../../Image/plats.png";
import DessertIcon from "../../Image/desserts.png";
import BoissonIcon from "../../Image/boisson.png";
import Money from "../../Image/money.png";
import Plus from "../../Image/plus.png";
import Menus from "../../Image/menus.png";
import Avatar1 from "../../Image/avatar1.png";
import Avatar2 from "../../Image/Avatar2.png";




import './css/carteResto.css';
const CarteMenu = () => {
  const [activePrix, setActivePrix] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [fullscreen, setFullscreen] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loadData, setLoadData] = useState(false);

  const [pdejeuner, setPdejeuner] = useState([]);

  const [errorPdejeuner, setErrorPdejeuner] = useState('');
  const [errorPdejeunerPrix, setErrorPdejeunerPrix] = useState('');
  const [errorPdejeunerLibelle, setErrorPdejeunerLibelle] = useState('');

  const [errorEntrer, setErrorEntrer] = useState('');
  const [errorEntrerPrix, setErrorEntrerPrix] = useState('');
  const [errorEntrerLibelle, setErrorEntrerLibelle] = useState('');

  const [errorPlat, setErrorPlat] = useState('');
  const [errorPlatPrix, setErrorPlatPrix] = useState('');
  const [errorPlatLibelle, setErrorPlatLibelle] = useState('');

  const [errorDessert, setErrorDessert] = useState('');
  const [errorDessertPrix, setErrorDessertPrix] = useState('');
  const [errorDessertLibelle, setErrorDessertLibelle] = useState('');

  const [errorBoisson, setErrorBoisson] = useState('');




  const [champPdejeuner, setChampPdejeuner] = useState({
    libelle: "",
    prix: ""
  });


  const [entrer, setEntrer] = useState([]);
  const [champEntrer, setChampEntrer] = useState({
    libelle: "",
    prix: ""
  });


  const [plat, setPlat] = useState([]);
  const [champPlat, setChampPlat] = useState({
    libelle: "",
    prix: ""
  });




  const [dessert, setDessert] = useState([]);
  const [champDessert, setChampDessert] = useState({
    libelle: "",
    prix: ""
  });


  const [boisson, setBoisson] = useState([]);





  // Visualiser

  const [show, setShow] = useState(false);
  const [showSpecial, setShowSpecial] = useState(false);


  const [menuResto, setMenuResto] = useState([]);
  const [elementMenu, setElementMenu] = useState([]);
  const [description, setDescription] = useState("");
  const [planUrl, setPlanUrl] = useState("");
  const [precision, setPrecision] = useState("");
  const [selectImage, setSelectImage] = useState([]);
  const [cuisine, setCuisine] = useState([]);
  const [promoSpecial, setPromoSpecial] = useState([]);
  const [promotion, setPromotion] = useState([]);


  const trueBoisson = boisson.filter((el) => el.status === true);
  const [service, setService] = useState([]);
  const [regime, setRegime] = useState([]);
  const [payement, setPayement] = useState([]);



  var settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    pauseOnHover: true,
    speed: 2000,
    autoplaySpeed: 8000,
    swipeToSlide: true,
    slidesToShow: selectImage.length < 4 ? selectImage.length : 4,
    slidesToScroll: selectImage.length < 4 ? selectImage.length : 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: selectImage.length < 3 ? selectImage.length : 3,
          slidesToScroll: selectImage.length < 3 ? selectImage.length : 3,
          initialSlide: selectImage.length < 3 ? selectImage.length : 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: selectImage.length < 2 ? selectImage.length : 2,
          slidesToScroll: selectImage.length < 2 ? selectImage.length : 2,
          initialSlide: selectImage.length < 2 ? selectImage.length : 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: selectImage.length < 1 ? selectImage.length : 1,
          slidesToScroll: selectImage.length < 1 ? selectImage.length : 1
        }
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: selectImage.length < 1 ? selectImage.length : 1,
          slidesToScroll: selectImage.length < 1 ? selectImage.length : 1
        }
      }
    ]
  };



  const handleCloseDetailMenu = () => setShow(false);
  const handleShowDetailMenu = (el) => {
    setElementMenu(el);
    setShow(true);

  };

  const handleCloseDetailSpecial = () => setShowSpecial(false);
  const handleShowDetailSPecial = () => {
    setShowSpecial(true);

  };

  const viewPromotion = () => {
    const existePromo50 = promotion.find((el) => el.libelle === "Promotion de -50%");
    const existePromo40 = promotion.find((el) => el.libelle === "Promotion de -40%");
    const existePromo30 = promotion.find((el) => el.libelle === "Promotion de -30%");
    const existePromo20 = promotion.find((el) => el.libelle === "Promotion de -20%");
    const existePromo10 = promotion.find((el) => el.libelle === "Promotion de -10%");
    const existePromoSpecial = promotion.find((el) => el.libelle === "Promotion : Menu spécial");

    if (existePromo50) {
      return (<span><i className='fa fa-bullhorn'></i>Promotion -50%</span>);
    } else if (existePromo40) {
      return (<span><i className='fa fa-bullhorn'></i>Promotion -40%</span>);
    } else if (existePromo30) {
      return (<span><i className='fa fa-bullhorn'></i>Promotion -30%</span>);
    } else if (existePromo20) {
      return (<span><i className='fa fa-bullhorn'></i>Promotion -20%</span>);
    } else if (existePromo10) {
      return (<span><i className='fa fa-bullhorn'></i>Promotion -10%</span>);
    } else if (existePromoSpecial) {
      return (<span><i className='fa fa-bullhorn'></i>Menu spécial</span>);

    } else {
      return (<span><i className='fa fa-bullhorn'></i>Pas de promotion ...</span>);
    }


  }




  const viewCreneau = (creneau) => {
    var opt_month = { month: 'long' };
    function toTitleCase(str) {
      return str.replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
      );
    }
    var MonthDu = toTitleCase(new Date(creneau.du).toLocaleDateString("fr-FR", opt_month));
    var MonthAu = toTitleCase(new Date(creneau.au).toLocaleDateString("fr-FR", opt_month));
    const du = new Date(creneau.du);
    const au = new Date(creneau.au);
    const fin = new Date(creneau?.au).getTime();
    const date = new Date();
    if (fin >= date.getTime()) {
      return (<p>{du.getDate() + " " + MonthDu + " " + du.getFullYear()} au {au.getDate() + " " + MonthAu + " " + au.getFullYear()}</p>);
    } else {
      return (<p>Promotion Expirée !</p>)
    }
  }



  // Fin visualiser




  let location = useLocation();


  const restaurant = useSelector((state) => state.restaurant);



  const handleClose = () => setShowModal(false);
  const handleShow = (breakpoint) => {
    setFullscreen(breakpoint);
    setShowModal(true);
  };



  useEffect(() => {
    AffichedataBoisson();
    carte();
    carteRestaurant();
  }, []);


  const AffichedataBoisson = () => {
    AfficheBoisson().then(function (response) {
      console.log(response.data.donner);
      response.data.donner.map((el, i) => {
        return setBoisson((prev) => [...prev, { id: i + 1, name: el.libelle, prix: "", errorBoisson: "", status: false }])
      });
    });
  }

  const carte = () => {
    setLoadData(true);
    AfficheCarte(restaurant.id).then(function (response) {
      console.log(response.data.donner);
      response.data.donner.boissons.map((el) =>
        setBoisson((prev) => {
          return prev.map((item) => {
            if (item.name === el.libelle) {
              return { ...item, status: true, prix: el.prix };
            } else {
              return { ...item };
            }
          });
        }));

      response.data.donner.desserts.map((el) =>
        setDessert((prev) => [...prev, { "libelle": el.libelle, "prix": parseInt(el.prix) }]));

      response.data.donner.entrers.map((el) =>
        setEntrer((prev) => [...prev, { "libelle": el.libelle, "prix": parseInt(el.prix) }]));


      response.data.donner.plats.map((el) =>
        setPlat((prev) => [...prev, { "libelle": el.libelle, "prix": parseInt(el.prix) }]));


      response.data.donner.petitDejeuners.map((el) =>
        setPdejeuner((prev) => [...prev, { "libelle": el.libelle, "prix": parseInt(el.prix) }]));

    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setLoadData(false);
    });
  }



  const carteRestaurant = () => {
    setLoadData(true);
    AfficheCarteRestaurant(restaurant.id).then(function (response) {
      console.log('Restaurant carte =>', response.data.donner);
      setDescription(response.data.donner.description);
      setPlanUrl(response.data.donner.urlPlan);
      setPrecision(response.data.donner.precision);
      setPromotion(response.data.donner.promotions);
      setPromoSpecial(response.data.donner.promoSpecial);
      setMenuResto(response.data.donner.menus);
      setCuisine(response.data.donner.typeCuisines);
      setSelectImage(response.data.donner.photos);
      setService(response.data.donner.serviceRestaurant);
      setPayement(response.data.donner.payements);
      setRegime(response.data.donner.regimeAlimentaires);

    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setLoadData(false);
    });
  }




  const handlePdejeuner = (e) => {
    setChampPdejeuner({
      ...champPdejeuner,
      [e.target.name]: e.target.value
    })
  }
  const handleAddPdejeuner = (e) => {
    e.preventDefault();
    const existePdejeuner = pdejeuner.find((el) => el.libelle === champPdejeuner.libelle);
    if (pdejeuner.length < 5) {
      if (existePdejeuner) {
        setErrorPdejeuner('Ce donner existe déjas !');
        const timer = setTimeout(() => setErrorPdejeuner(''), 3000);
        return () => clearTimeout(timer);
      } else {
        if (champPdejeuner.libelle === "" && champPdejeuner.prix === "") {
          setErrorPdejeunerLibelle('Libelle obligatoire !');
          setErrorPdejeunerPrix('Prix obligatoire !');
          const timer = setTimeout(() => {
            setErrorPdejeunerLibelle('');
            setErrorPdejeunerPrix('');
          }, 3000);
          return () => clearTimeout(timer);
        } else if (champPdejeuner.libelle !== "" && champPdejeuner.prix === "") {
          setErrorPdejeunerPrix('Prix obligatoire !');
          const timer = setTimeout(() => setErrorPdejeunerPrix(''), 3000);
          return () => clearTimeout(timer);
        } else if (champPdejeuner.libelle === "" && champPdejeuner.prix !== "") {
          setErrorPdejeunerLibelle('Libelle obligatoire !');
          const timer = setTimeout(() => setErrorPdejeunerLibelle(''), 3000);
          return () => clearTimeout(timer);
        } else {
          setErrorEntrer('');
          setErrorDessert('');
          setErrorPdejeuner('');
          setErrorPlat('');
          setChampPdejeuner({
            libelle: "",
            prix: ""
          });
          setPdejeuner([...pdejeuner, { "libelle": champPdejeuner.libelle, "prix": parseInt(champPdejeuner.prix) }]);
        }
      }
    } else {
      setErrorPdejeuner('Donner max 5 !');
      const timer = setTimeout(() => setErrorPdejeuner(''), 3000);
      return () => clearTimeout(timer);
    }

  }
  const handleDeleteDejeuner = (libelle) => {
    setPdejeuner(pdejeuner.filter((el) => el.libelle !== libelle));
  }







  const handleEntrer = (e) => {
    setChampEntrer({
      ...champEntrer,
      [e.target.name]: e.target.value
    })
  }

  const handleAddEntrer = (e) => {

    e.preventDefault();
    const existEntrer = entrer.find((el) => el.libelle === champEntrer.libelle);
    if (entrer.length < 5) {
      if (existEntrer) {
        setErrorEntrer('Ce libeller existe déjas');
        const timer = setTimeout(() => setErrorEntrer(''), 3000);
        return () => clearTimeout(timer);
      } else {
        if (champEntrer.libelle === "" && champEntrer.prix === "") {
          setErrorEntrerLibelle('Libelle obligatoire !');
          setErrorEntrerPrix('Prix obligatoire');
          const timer = setTimeout(() => {
            setErrorEntrerPrix('');
            setErrorEntrerLibelle('');
          }, 3000);
          return () => clearTimeout(timer);
        } else if (champEntrer.libelle !== "" && champEntrer.prix === "") {
          setErrorEntrerPrix('Prix obligatoire');
          const timer = setTimeout(() => setErrorEntrerPrix(''), 3000);
          return () => clearTimeout(timer);
        } else if (champEntrer.libelle === "" && champEntrer.prix !== "") {
          setErrorEntrerLibelle('Libelle obligatoire');
          const timer = setTimeout(() => setErrorEntrerLibelle(''), 3000);
          return () => clearTimeout(timer);
        } else {
          setChampEntrer({
            libelle: "",
            prix: ""
          });
          setErrorEntrer('');
          setErrorDessert('');
          setErrorPdejeuner('');
          setErrorPlat('');
          setEntrer([...entrer, { "libelle": champEntrer.libelle, "prix": parseInt(champEntrer.prix) }]);
        }
      }
    } else {
      setErrorEntrer('Donner max 5 !');
      const timer = setTimeout(() => setErrorEntrer(''), 3000);
      return () => clearTimeout(timer);
    }

  }

  const handleDeleteEntrer = (libelle) => {
    setEntrer(entrer.filter((el) => el.libelle !== libelle));
  }




  const handlePlat = (e) => {
    setChampPlat({
      ...champPlat,
      [e.target.name]: e.target.value
    })
  }

  const handleAddPlat = (e) => {
    e.preventDefault();
    const existPlat = plat.find((el) => el.libelle === champPlat.libelle);
    if (plat.length < 5) {
      if (existPlat) {
        setErrorPlat('Donner existe déjas');
        const timer = setTimeout(() => setErrorPlat(''), 3000);
        return () => clearTimeout(timer);
      } else {
        if (champPlat.libelle === "" && champPlat.prix === "") {
          setErrorPlatLibelle('Libelle obligatoire');
          setErrorPlatPrix('Prix obligatoire');
          const timer = setTimeout(() => {
            setErrorPlatLibelle('');
            setErrorPlatPrix('');
          }, 3000);
          return () => clearTimeout(timer);
        } else if (champPlat.libelle !== "" && champPlat.prix === "") {

          setErrorPlatPrix('Prix obligatoire');
          const timer = setTimeout(() => setErrorPlatPrix(''), 3000);
          return () => clearTimeout(timer);
        } else if (champPlat.libelle === "" && champPlat.prix !== "") {
          setErrorPlatLibelle('Libelle obligatoire');
          const timer = setTimeout(() => setErrorPlatLibelle(''), 3000);
          return () => clearTimeout(timer);
        } else {
          setChampPlat({
            libelle: "",
            prix: ""
          });
          setErrorEntrer('');
          setErrorDessert('');
          setErrorPdejeuner('');
          setErrorPlat('');

          setPlat([...plat, { "libelle": champPlat.libelle, "prix": parseInt(champPlat.prix) }]);

        }
      }
    } else {
      setErrorPlat('Donner max 5');
      const timer = setTimeout(() => setErrorPlat(''), 3000);
      return () => clearTimeout(timer);
    }

  }

  const handleDeletePlat = (libelle) => {
    setPlat(plat.filter((el) => el.libelle !== libelle));
  }



  const handleDessert = (e) => {
    setChampDessert({
      ...champDessert,
      [e.target.name]: e.target.value
    })
  }

  const handleAddDessert = (e) => {
    e.preventDefault();
    const existDessert = dessert.find((el) => el.libelle === champDessert.libelle);
    if (dessert.length < 5) {
      if (existDessert) {
        setErrorDessert('Donner existe déjas !');
        const timer = setTimeout(() => setErrorDessert(''), 3000);
        return () => clearTimeout(timer);
      } else {
        if (champDessert.libelle === "" && champDessert.prix === "") {
          setErrorDessertLibelle('Libelle obligatoire !');
          setErrorDessertPrix('Prix obligatoire !');
          const timer = setTimeout(() => {
            setErrorDessertPrix('');
            setErrorDessertLibelle('');
          }, 3000);
          return () => clearTimeout(timer);
        } else if (champDessert.libelle !== "" && champDessert.prix === "") {
          setErrorDessertPrix('Prix obligatoire !');
          const timer = setTimeout(() => {
            setErrorDessertPrix('');
          }, 3000);
          return () => clearTimeout(timer);
        } else if (champDessert.libelle === "" && champDessert.prix !== "") {
          setErrorDessertLibelle('Libelle obligatoire !');
          const timer = setTimeout(() => {
            setErrorDessertLibelle('');
          }, 3000);
          return () => clearTimeout(timer);
        } else {
          setErrorEntrer('');
          setErrorDessert('');
          setErrorPdejeuner('');
          setErrorPlat('');

          setChampDessert({
            libelle: "",
            prix: ""
          });
          setDessert([...dessert, { "libelle": champDessert.libelle, "prix": parseInt(champDessert.prix) }]);

        }
      }
    } else {
      setErrorDessert('Donner max 5 !');
      const timer = setTimeout(() => setErrorDessert(''), 3000);
      return () => clearTimeout(timer);
    }


  }

  const handleDeleteDessert = (libelle) => {
    setDessert(dessert.filter((el) => el.libelle !== libelle));
  }


  const handleCheckBoisson = id => {
    setBoisson((prev) => {
      return prev.map((item) => {
        if (item.id === id) {
          if (item.prix === "" && item.status === false) {
            return { ...item, errorBoisson: "Prix obligatoire", status: !item.status };
          } else {
            return { ...item, errorBoisson: "", status: !item.status };
          }
        } else {
          return { ...item };
        }
      });
    });
  }


  const handleAddBoissonPrix = (e, id) => {
    setBoisson((prev) => {
      return prev.map((item) => {
        if (item.id === id) {
          if (item.status === true && item.prix.length <= 1) {
            return { ...item, errorBoisson: "Prix obligatoire", prix: e.target.value, status: true };
          } else {
            setErrorBoisson('');
            return { ...item, errorBoisson: "", prix: e.target.value, status: true };
          }

        } else {
          return { ...item };
        }
      });
    });

  }

  const dataBoisson = boisson.filter((el) => el.status === true);





  const safeParseFloat = (str) => {

    const value = Number.parseFloat(str);

    return Number.isNaN(value) ? 0 : value;
  }

  const moyen = () => {
    let moyenEntrer = safeParseFloat(entrer.reduce((prevPrix, currentPrix) => prevPrix + currentPrix.prix, 0) / entrer.length);
    let moyenPlat = safeParseFloat(plat.reduce((prevPrix, currentPrix) => prevPrix + currentPrix.prix, 0) / plat.length);
    let moyenDessert = safeParseFloat(dessert.reduce((prevPrix, currentPrix) => prevPrix + currentPrix.prix, 0) / dessert.length);
    let moyen = moyenEntrer + moyenPlat + moyenDessert;

    return moyen.toFixed(2);
  }

  console.log(dataBoisson);





  const handleAddCarte = () => {
    if (!localStorage.getItem('tokenSociete')) {
      setLoading(true);
      const data = { idRestaurant: restaurant.id, entrer: entrer, plat: plat, dessert: dessert, petitDejeuner: pdejeuner, boisson: dataBoisson, prixMoyenne: moyen(), statusPrixCarte: activePrix };
      AjouteCarte(data).then(function (response) {
        if (response.data.title === "success") {
          toast.success(response.data.message);
          setEntrer([]);
          setDessert([]);
          setPlat([]);
          setPdejeuner([]);
          carte();
        }
      }).catch(function (error) {
        console.log(error.response);
        toast.warning(error.response.data.message);
      }).finally(function () {
        setLoading(false);

      });
    } else {
      toast.warning("Vous n'êtes pas autorisé à modifier ces éléments");
    }
  }


  const handleCancel = () => {
    setEntrer([]);
    setDessert([]);
    setPlat([]);
    setPdejeuner([]);
    carte();
  }



  const plural = (value) => {
    if (value < 10) {
      return "0" + value;
    } else {
      return value;
    }
  }

  const viewDate = (value) => {
    const date = new Date(value);
    return plural(date.getDate()) + "/" + plural(parseInt(date.getUTCMonth() + 1)) + "/" + date.getFullYear();
  }



  const viewAvisListe = (item, index) => {
    const nom = item.client.nom.charAt(0).toUpperCase();
    const prenom = item.client.prenom.charAt(0).toUpperCase();
    const clientAvis = restaurant.avis.filter((el) => el.client.id === item.client.id);
    return (
      <div className='resto_avis_liste' key={index}>
        <div className='row'>
          <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
            <div className='resto_avis_profile'>
              <div className='resto_avatar_client'>
                {
                  item.client.sexe === "Homme" ? <img src={Avatar2} alt="avatar client" /> : <img src={Avatar1} alt="avatar client" />
                }
              </div>
              {item.client.affichagePseudo === "1" ?
                <div className='pseudoClient d-flex flex-column'>
                  <span>{item.client.nom}</span>
                  <span className='text-center'>{item.client.prenom}</span>
                </div>
                : item.client.affichagePseudo === "2" ?
                  <span>{item.client.prenom} {nom}</span>
                  : item.client.affichagePseudo === "3" ?
                    <span>{prenom} {item.client.prenom}</span>
                    : <span>{nom} {prenom}</span>}
            </div>
          </div>
          <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
            <div className='resto_note_avis'>
              <div className='d-flex justify-content-center'>
                <div className='note_avis_content'>
                  <div>
                    <div className='resto_note_value'>Note/<span>{item.notes[0]?.note}</span></div>
                    <div className='resto_avis_value'>Avis/<span>{clientAvis.length}</span></div>
                  </div>
                </div>
              </div>
              <div className='resto_avis_date'>
                <span>{viewDate(item.createdAt)}</span>
              </div>
            </div>
          </div>
          <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
            <div className='resto_content_avis'>
              <p>{item.avis}</p>
            </div>
          </div>
        </div>
      </div>
    )
  }



  return (
    <div>
      <Helmet>
        <title>Carte</title>
        <meta name='description' content='Restaurant à la carte.' />
        <link rel='canonical' href={location.pathname} />
      </Helmet>
      <div className='carte'>
        <div className='container'>
          <div className='bloc_carte'>
            <div className="item_carte">
              <div className='d-flex mt-2 titre'>
                <i className='fa fa-cutlery'></i> <h1>A la carte</h1>
              </div>
              <div className='renseignement'>
                <p>Pensez à ne mettre que « les » quelques plats qui « attireront » vos clients.
                  Pour chaque donnée renseignée, le prix est à renseigner obligatoirement, mais peut ne pas être affiché sur votre fiche client. Cependant il est souhaitable que vous l’affichez car peut être un critère important pour le client.
                  Veillez à mettre à jour cette page lors de vos changements de carte – plats et/ou prix.
                  Les prix des boissons s’entendent « à partir de »
                </p>
              </div>
            </div>
            <div className="item_liste">
              <div className='active_prix'>
                <div className='d-flex justify-content-end mt-2'>
                  <h2>Afficher les prix sur la fiche Resto</h2>
                  <Form>
                    <Form.Check
                      type="switch"
                      defaultChecked={activePrix}
                      id="custom-switch"
                      onChange={() => setActivePrix(true)}
                    />
                  </Form>
                </div>
              </div>
              <div className='liste_carte'>
                <div className='row'>

                  <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    <div className='liste_item'>
                      <div className='liste_item_titre'>
                        <h3>Petit-déjeuner</h3>
                        <i className="fa fa-cutlery"></i>
                      </div>


                      <div className='d-flex'>
                        <div>
                          <input type="text" className='form-control' value={champPdejeuner.libelle} onChange={handlePdejeuner} name="libelle" placeholder='Libelle ...' />
                          {errorPdejeunerLibelle !== "" ?
                            <span className="errorValue ms-1">{errorPdejeunerLibelle}</span>
                            : ''}
                        </div>
                        <div className="ms-3">
                          <input type="number" onKeyDown={blockInvalidChar} className='form-control' value={champPdejeuner.prix} name="prix" onChange={handlePdejeuner} placeholder='Prix ex: 20 000 ...' />
                          {errorPdejeunerPrix !== "" ?
                            <span className="errorValue ms-1">{errorPdejeunerPrix}</span>
                            : ''}
                        </div>
                        <span className='ar ms-3'>Ar</span>
                        <button type="button" className='btn' onClick={handleAddPdejeuner}><i className="fa fa-plus"></i></button>
                      </div>
                      {errorPdejeuner !== "" ?
                        <span className="errorValue">{errorPdejeuner}</span>
                        : ''}
                      {loadData === true ?
                        <div className="d-flex justify-content-center">
                          <Spinner animation="border" className="load" variant="info" size="md" />
                        </div>
                        :
                        pdejeuner?.length !== 0 ?
                          pdejeuner.map((el, index) => {
                            return (
                              <div className='carte_menu' key={index}>
                                <div className='d-flex justify-content-between'>
                                  <h4>{el.libelle}</h4>
                                  <div className='d-flex'>
                                    <span>{el.prix} AR</span>
                                    <button className="btn btn_delete btn-sm" onClick={() => handleDeleteDejeuner(el.libelle)}><i className='fa fa-trash'></i></button>
                                  </div>
                                </div>
                              </div>
                            );
                          }) : <p className='mt-1'>Petit-déjeuner vide...</p>
                      }

                    </div>
                  </div>


                  <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    <div className='liste_item'>
                      <div className='liste_item_titre'>
                        <h3>Entrées</h3>
                        <i className="fa fa-cutlery"></i>
                      </div>
                      <div className='d-flex'>
                        <div>
                          <input type="text" className='form-control' value={champEntrer.libelle} name="libelle" onChange={handleEntrer} placeholder='Libelle ...' />
                          {errorEntrerLibelle !== "" ?
                            <span className="errorValue ms-1">{errorEntrerLibelle}</span>
                            : ''}
                        </div>
                        <div className='ms-3'>
                          <input type="number" onKeyDown={blockInvalidChar} className='form-control' value={champEntrer.prix} name="prix" onChange={handleEntrer} placeholder='Prix ex: 20 000 ...' />

                          {errorEntrerPrix !== "" ?
                            <span className="errorValue ms-1">{errorEntrerPrix}</span>
                            : ''}
                        </div>
                        <span className='ar ms-3'>Ar</span>
                        <button type="submit" className='btn' onClick={handleAddEntrer}><i className="fa fa-plus"></i></button>
                      </div>

                      {errorEntrer !== "" ?
                        <span className="errorValue">{errorEntrer}</span>
                        : ''}
                      {loadData === true ?
                        <div className="d-flex justify-content-center">
                          <Spinner animation="border" className="load" variant="info" size="md" />
                        </div>
                        :
                        entrer?.length !== 0 ?
                          entrer.map((el, index) => {
                            return (
                              <div className='carte_menu' key={index}>
                                <div className='d-flex justify-content-between'>
                                  <h4>{el.libelle}</h4>
                                  <div className='d-flex'>
                                    <span>{el.prix} AR</span>
                                    <button className="btn btn_delete btn-sm" onClick={() => handleDeleteEntrer(el.libelle)}><i className='fa fa-trash'></i></button>
                                  </div>
                                </div>
                              </div>
                            );
                          }) : <p className='mt-1'>Entrées vide...</p>}

                    </div>
                  </div>
                  <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    <div className='liste_item'>
                      <div className='liste_item_titre'>
                        <h3>Plats</h3>
                        <i className="fa fa-cutlery"></i>
                      </div>

                      <div className='d-flex'>
                        <div>
                          <input type="text" className='form-control' value={champPlat.libelle} onChange={handlePlat} name="libelle" placeholder='Libelle ...' />
                          {errorPlatLibelle !== "" ?
                            <span className="errorValue">{errorPlatLibelle}</span>
                            : ''}
                        </div>
                        <div className="ms-3">
                          <input type="number" onKeyDown={blockInvalidChar} className='form-control' value={champPlat.prix} onChange={handlePlat} name="prix" placeholder='Prix ex: 20 000 ...' />
                          {errorPlatPrix !== "" ?
                            <span className="errorValue">{errorPlatPrix}</span>
                            : ''}
                        </div>
                        <span className='ar ms-3'>Ar</span>
                        <button type="submit" className='btn' onClick={handleAddPlat}><i className="fa fa-plus"></i></button>
                      </div>
                      {errorPlat !== "" ?
                        <span className="errorValue">{errorPlat}</span>
                        : ''}
                      {loadData === true ?
                        <div className="d-flex justify-content-center">
                          <Spinner animation="border" className="load" variant="info" size="md" />
                        </div>
                        : plat?.length !== 0 ?
                          plat.map((el, index) => {
                            return (
                              <div className='carte_menu' key={index}>
                                <div className='d-flex justify-content-between'>
                                  <h4>{el.libelle}</h4>
                                  <div className='d-flex'>
                                    <span>{el.prix} AR</span>
                                    <button className="btn btn_delete btn-sm" onClick={() => handleDeletePlat(el.libelle)}><i className='fa fa-trash'></i></button>
                                  </div>
                                </div>
                              </div>
                            );
                          }) : <p className='mt-1'>Plats vide...</p>}

                    </div>
                  </div>
                  <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    <div className='liste_item'>
                      <div className='liste_item_titre'>
                        <h3>Desserts</h3>
                        <i className="fa fa-cutlery"></i>
                      </div>
                      <div className='d-flex'>
                        <div>
                          <input type="text" className='form-control' value={champDessert.libelle} onChange={handleDessert} name="libelle" placeholder='Libelle ...' />
                          {errorDessertLibelle !== "" ?
                            <span className="errorValue">{errorDessertLibelle}</span>
                            : ''}
                        </div>
                        <div className='ms-3'>
                          <input type="number" onKeyDown={blockInvalidChar} className='form-control' pattern="[0-9]" value={champDessert.prix} onChange={handleDessert} name="prix" placeholder='Prix ex: 20 000 ...' />
                          {errorDessertPrix !== "" ?
                            <span className="errorValue">{errorDessertPrix}</span>
                            : ''}
                        </div>
                        <span className='ar ms-3'>Ar</span>
                        <button type="submit" className='btn' onClick={handleAddDessert} ><i className="fa fa-plus"></i></button>
                      </div>
                      {errorDessert !== "" ?
                        <span className="errorValue">{errorDessert}</span>
                        : ''}
                      {loadData === true ?
                        <div className="d-flex justify-content-center">
                          <Spinner animation="border" className="load" variant="info" size="md" />
                        </div>
                        : dessert?.length !== 0 ?
                          dessert.map((el, index) => {
                            return (
                              <div className='carte_menu' key={index}>
                                <div className='d-flex justify-content-between'>
                                  <h4>{el.libelle}</h4>
                                  <div className='d-flex'>
                                    <span>{el.prix} AR</span>
                                    <button className="btn btn_delete btn-sm" onClick={() => handleDeleteDessert(el.libelle)}><i className='fa fa-trash'></i></button>
                                  </div>
                                </div>
                              </div>
                            );
                          }) : <p className='mt-1'>Desserts vide...</p>
                      }


                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='footer_item'>
              <div className='liste_boison'>
                <div className="d-flex">
                  <i className='fa fa-coffee'></i>
                  <h3>Boissons</h3>
                </div>
                {errorBoisson !== "" ?
                  <span className="errorValue">{errorBoisson}</span>
                  : ''}
                <div className='row'>
                  {boisson.length === 0 ? <p>Pas disponible ...</p> : boisson.map((boisson, index) => {
                    return (
                      <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6' key={index}>
                        <div className='item_boison pr-5'>
                          <div className='d-flex justify-content-between mt-2'>
                            <Form.Check
                              type="switch"
                              id={boisson.name}
                              label={boisson.name}
                              onChange={() => handleCheckBoisson(boisson.id)}
                              checked={boisson.status}
                            />
                            <div>
                              <div className='d-flex'>
                                <input type="number" onKeyDown={blockInvalidChar} name="prix" placeholder='Prix ex: 20 000' onChange={(e) => handleAddBoissonPrix(e, boisson.id)} className='form-control boisson_prix' value={boisson.prix} />
                                <span className="ar">Ar</span>
                              </div>
                              {boisson.errorBoisson !== "" ? <p className="errorValue mt-1">{boisson.errorBoisson}</p> : ''}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className='action'>
                <div className='d-flex justify-content-between action_carte'>
                  <div className='prix_moyen'>
                    <span>Prix moyen : {moyen()} Ar</span>
                  </div>
                  <div className='liste_action'>
                    <button className='btn' onClick={() => handleShow(true)}>Visualiser</button>
                    <button className='btn' onClick={handleCancel}>Annuler</button>
                    {loading ? <Button className='btn btn_ajouteCarte' disabled>
                      <Spinner

                        animation="border"
                        size="sm"

                        variant="info"

                      />
                      Loading...
                    </Button> : <button className='btn' onClick={handleAddCarte}>Publier</button>}
                  </div>
                </div>
              </div>
              <p className='version'>Version 1</p>
            </div>
          </div>
        </div>

        {/* ==================================== MODAL COMPONENT  ============================== */}



        <Modal show={showModal} fullscreen={fullscreen} onHide={handleClose}>
          <Modal.Body>
            <div className='modal_visualiser'>
              <div className='modal_visualiser_header'>
                <h5>L'aperçue de votre donner dans la page restaurants</h5>
                <span className='close' onClick={handleClose}><i className='fa fa-close'></i></span>
              </div>

              <div className='restoPageCarte'>
                <div className='restoPage_content'>
                  <div className='resto_option'>
                    <div className='row'>
                      <div className='col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8'>
                        <div className='resto_apropos'>
                          <div className='resto_apropos_content'>
                            <h1 className='text-center'>{restaurant.nomRestaurant}</h1>
                            <div className='cuisine_prix'>
                              <div className="row">

                                {cuisine.length !== 0 ?
                                  cuisine.map((item, index) => {
                                    return (
                                      <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 mt-3' key={index}>
                                        <span ><i className='fa fa-cutlery'></i>{item.libelle}</span>
                                      </div>
                                    )
                                  })
                                  : ''}

                              </div>
                              <div className='row'>
                                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
                                  <span><i className='fa fa-map-marker'></i>{restaurant.adresse}</span>
                                </div>
                                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
                                  <span><i className='fa fa-bookmark'></i>Prix Moyenne de {moyen()} Ar</span>
                                </div>

                              </div>
                            </div>
                            <div className='favoris_gif'>
                              <i className='fa fa-heart'></i>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4'>
                        <div className='resto_favoris'>
                          <div className='resto_favoris_content'>
                            <div className="d-flex justify-content-center">
                              <div className='resto_note_avis'>
                                <div>
                                  <div className='resto_note'>Note/<span>{restaurant.notes && restaurant.notes.length === 0 ? 0 : restaurant.notes[0].note}</span></div>
                                  <div className='resto_avis'>Avis/<span>{restaurant.avis && restaurant.avis.length === 0 ? 0 : restaurant.avis.length}</span></div>
                                </div>
                              </div>
                            </div>

                            <div className="d-flex justify-content-center">
                              {restaurant.promotions.length === 0 ? <div className='resto_promotion mb-4'>
                                {viewPromotion()}
                              </div> :
                                <div className='resto_promotion'>
                                  {viewPromotion()}
                                  {restaurant.creneauPromos.lenght !== 0 ?
                                    viewCreneau(restaurant.creneauPromos[0])
                                    : ''}
                                </div>}
                            </div>
                          </div>
                          <div className='resto_footer_reserver'>
                            <div className='d-flex justify-content-center'>
                              <button className="btn">Réserver</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='resto_photos'>
                    <PhotoProvider>
                      {selectImage.length !== 0 ?
                        <Slider {...settings}>
                          {selectImage.map((el, index) => {
                            return (<div className='image' key={index}>
                              <PhotoView src={BASE_URL + el.urlPhoto}>
                                <img src={BASE_URL + el.urlPhoto} alt="logo restaurant" />
                              </PhotoView>
                            </div>)
                          })}
                        </Slider>
                        : <p>Photos non disponible ...</p>}
                    </PhotoProvider>
                  </div>
                  <div className='resto_description'>
                    <h2> <i className='fa fa-tag'></i>Description du restaurant</h2>
                    <div className='resto_description_content'>
                      <div className='chef'>
                        <img src={Chef} alt="chef avatar" />
                      </div>
                      <p>{description === null ? 'Description non disponible ...' : description.split('\n').map((line, index) => (
                        <div key={index}>{line}</div>
                      ))}</p>
                    </div>

                  </div>



                  <div className='row'>


                    <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8'>
                      <Tabs
                        defaultActiveKey="carte"
                        id="fill-tab-example"
                        className="mb-3"
                        justify
                      >
                        <Tab eventKey="carte" title="Cartes">
                          {entrer.length === 0 && plat.length === 0 && dessert.length === 0 && trueBoisson.length === 0 ?
                            <h4> <i className='fa fa-cutlery pas'></i>Pas de contenue dans la carte</h4>
                            :
                            <h4> <i className='fa fa-cutlery'></i>A la carte</h4>
                          }

                          <div className='resto_carte'>
                            <div className='row'>
                              {entrer.length !== 0 ?
                                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                  <div className='resto_carte_bloc'>
                                    <h5 className='text-center'>Entrées</h5>
                                    {entrer.map((item, index) => {
                                      if (index === entrer.length - 1) {
                                        return (<div className='resto_entrer' key={index}>
                                          <div className='img'>
                                            <img src={EntrerIcon} alt="avatar carte" />
                                          </div>
                                          <div className='resto_carte_content'>
                                            <h6>{item.libelle}</h6>
                                            <span>{item.prix} Ar</span>
                                          </div>
                                        </div>)
                                      } else {
                                        return (<>
                                          <div className='resto_entrer' key={index}>
                                            <div className='img'>
                                              <img src={EntrerIcon} alt="avatar carte" />
                                            </div>
                                            <div className='resto_carte_content'>
                                              <h6>{item.libelle}</h6>
                                              <span>{item.prix} Ar</span>
                                            </div>
                                          </div>
                                          <hr />
                                        </>)
                                      }

                                    })}


                                  </div>
                                </div>
                                : ''}

                              {plat.length !== 0 ?
                                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                  <div className='resto_carte_bloc'>
                                    <h5 className='text-center'>Plats</h5>
                                    {plat.map((item, index) => {
                                      if (index === plat.length - 1) {
                                        return (<div className='resto_plat' key={index}>
                                          <div className='img'>
                                            <img src={PlatIcon} alt="avatar carte" />
                                          </div>
                                          <div className='resto_carte_content'>
                                            <h6>{item.libelle}</h6>
                                            <span>{item.prix} Ar</span>
                                          </div>
                                        </div>)
                                      } else {
                                        return (<>
                                          <div className='resto_plat' key={index}>
                                            <div className='img'>
                                              <img src={PlatIcon} alt="avatar carte" />
                                            </div>
                                            <div className='resto_carte_content'>
                                              <h6>{item.libelle}</h6>
                                              <span>{item.prix} Ar</span>
                                            </div>
                                          </div>
                                          <hr />
                                        </>
                                        )
                                      }

                                    })}

                                  </div>
                                </div>
                                : ''}


                              {dessert.length !== 0 ?
                                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
                                  <div className='resto_carte_bloc'>
                                    <h5 className='text-center'>Desserts</h5>

                                    {dessert.map((item, index) => {
                                      if (index === dessert.length - 1) {
                                        return (
                                          <div className='resto_dessert' key={index}>
                                            <div className='img'>
                                              <img src={DessertIcon} alt="avatar carte" />
                                            </div>
                                            <div className='resto_carte_content'>
                                              <h6>{item.libelle}</h6>
                                              <span>{item.prix} Ar</span>
                                            </div>
                                          </div>
                                        )
                                      } else {
                                        return (
                                          <>
                                            <div className='resto_dessert' key={index}>
                                              <div className='img'>
                                                <img src={DessertIcon} alt="avatar carte" />
                                              </div>
                                              <div className='resto_carte_content'>
                                                <h6>{item.libelle}</h6>
                                                <span>{item.prix} Ar</span>
                                              </div>
                                            </div>
                                            <hr />
                                          </>
                                        )
                                      }
                                    })}


                                  </div>

                                </div>
                                : ''}


                              {trueBoisson.length !== 0 ?

                                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
                                  <div className='resto_carte_bloc'>
                                    <h5 className='text-center boisson'>Boissons</h5>
                                    {trueBoisson.map((item, index) => {
                                      if (index === trueBoisson.length - 1) {
                                        return (
                                          <div className='resto_boisson' key={index}>
                                            <div className='img'>
                                              <img src={BoissonIcon} alt="avatar carte" />
                                            </div>
                                            <div className='resto_carte_content'>
                                              <h6>{item.name}</h6>
                                              <span>{item.prix} Ar</span>
                                            </div>
                                          </div>
                                        )
                                      } else {
                                        return (
                                          <>
                                            <div className='resto_boisson' key={index}>
                                              <div className='img'>
                                                <img src={BoissonIcon} alt="avatar carte" />
                                              </div>
                                              <div className='resto_carte_content'>
                                                <h6>{item.name}</h6>
                                                <span>{item.prix} Ar</span>
                                              </div>
                                            </div>
                                            <hr />
                                          </>
                                        )
                                      }
                                    })}



                                  </div>

                                </div>
                                : ''}

                            </div>
                          </div>
                        </Tab>



                        <Tab eventKey="menu" title="Menus">
                          {menuResto.length === 0 ? <h4> <i className='fa fa-cutlery pas'></i>Pas de contenu dans le Menus</h4> : <h4> <i className='fa fa-cutlery'></i>Menus</h4>}

                          <div className="row p-2">

                            {menuResto.map((item, index) => {
                              return (
                                <div className='col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4' key={index}>
                                  <div className='resto_menus'>
                                    <div className='resto_menu_header'>
                                      <div className='img'>
                                        <img src={Menus} alt="avatar menus" />
                                      </div>
                                      <div className='resto_menu_titre'>
                                        <h5>{item.nomMenu} à <span>{item.prixMenu} Ar</span></h5>
                                      </div>
                                    </div>
                                    <div className='resto_menu_content'>
                                      <p>{item.introduire.slice(0, 80)}...</p>
                                      <div className='d-flex justify-content-center'>
                                        <button className='btn' onClick={() => handleShowDetailMenu(item)}>Voir le détail de ce menu</button>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              );
                            })}

                          </div>


                        </Tab>



                        <Tab eventKey="avecOffre" title="Avec Offres">
                          <div className='resto_promo_map'>
                            <div className='row'>
                              <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                <div className='resto_promo_titre'>
                                  <h4> <i className='fa fa-bullhorn'></i>Avec Offre</h4>
                                </div>
                                <div className='resto_promo_content'>

                                  {promotion.length !== 0 ?
                                    promotion.map((elPromo, iPromo) => {
                                      if (elPromo.libelle === "Promotion de -50%") {
                                        return (<div className='resto_promo_content_item' key={iPromo}>
                                          <div className='item_liste'>
                                            <h5>Promo : -50% sur la carte</h5>
                                            <span>Précision / conditions / validité</span>
                                          </div>
                                        </div>);
                                      } else if (elPromo.libelle === "Promotion de -40%") {
                                        return (<div className='resto_promo_content_item' key={iPromo}>
                                          <div className='item_liste'>
                                            <h5>Promo : -40% sur la carte</h5>
                                            <span>Précision / conditions / validité</span>
                                          </div>
                                        </div>);
                                      } else if (elPromo.libelle === "Promotion de -30%") {
                                        return (<div className='resto_promo_content_item' key={iPromo}>
                                          <div className='item_liste'>
                                            <h5>Promo : -30% sur la carte</h5>
                                            <span>Précision / conditions / validité</span>
                                          </div>
                                        </div>);
                                      } else if (elPromo.libelle === "Promotion de -20%") {
                                        return (<div className='resto_promo_content_item' key={iPromo}>
                                          <div className='item_liste'>
                                            <h5>Promo : -20% sur la carte</h5>
                                            <span>Précision / conditions / validité</span>
                                          </div>
                                        </div>);
                                      } else if (elPromo.libelle === "Promotion de -10%") {
                                        return (<div className='resto_promo_content_item' key={iPromo}>
                                          <div className='item_liste'>
                                            <h5>Promo : -10% sur la carte</h5>
                                            <span>Précision / conditions / validité</span>
                                          </div>
                                        </div>);
                                      } else if (elPromo.libelle === "Promotion : Menu spécial") {
                                        return (<div className='resto_promo_content_item' key={iPromo}>
                                          <div className='item_liste'>
                                            <h5>Promo : {promoSpecial.length !== 0 ? promoSpecial[0].libelle : "Promotion special"} à {promoSpecial.length !== 0 ? promoSpecial[0].prix : "000"} Ar</h5>
                                            <span>Précision / conditions / validité</span>
                                          </div>
                                          <div className='item_action_creneau creneau_special'>
                                            {promoSpecial.lenght !== 0 ? <span className="item_detail_menu" onClick={handleShowDetailSPecial}>Voir le détail de ce menu</span> : ''}
                                          </div>
                                          <div className='item_action_content'>
                                            <div className='item_action_creneau_responsive'>
                                              {promoSpecial.lenght !== 0 ? <span className="item_detail_menu" onClick={handleShowDetailSPecial}>Voir le détail de ce menu</span> : ''}
                                            </div>
                                          </div>
                                        </div>)
                                      } else {
                                        return ("");
                                      }
                                    })
                                    : <p>Pas de promotion ...</p>}



                                </div>
                                <div className='resto_promo_titre mt-3'>
                                  <h4> <i className='fa fa-bullhorn'></i>Sans Offre</h4>
                                </div>
                                <div className='resto_promo_content'>
                                  <div className='resto_promo_content_item'>
                                    <div className='item_liste'>
                                      <h5>Réservations simple</h5>
                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </Tab>





                        <Tab eventKey="avis" title={"Nombre d'avis" + restaurant?.avis.length}>
                          <div className='resto_avis'>
                            <div className='resto_avis_header'>
                              <h4><i className='fa fa-tag'></i> Nombre d'avis {restaurant?.avis.length}</h4>
                            </div>
                            <div className='resto_avis_content'>

                              {restaurant?.avis.map((el, index) => {
                                return (
                                  viewAvisListe(el, index)
                                )
                              })}



                              {/* <div className='d-flex justify-content-center'>
                                                                    <div className='pagination_avis'>
                                                                        <Pagination count={10} />
                                                                    </div>
                                                                </div> */}
                            </div>
                          </div>
                        </Tab>
                      </Tabs>


                    </div>


                    <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4'>
                      <div className='payement_plus'>
                        <div className='payement_plusContent'>
                          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div className='plus_restaurant'>
                              <div className='d-flex justify-content-center'>
                                <div className='titre_plus'>
                                  <span><i className='fa fa-bolt'></i> Les + du restaurant</span>
                                </div>
                              </div>
                              <div className='plus_content'>
                                <div className='row'>
                                  {service?.length !== 0 ?
                                    service?.map((item, index) => {
                                      return (
                                        <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6' key={index}>
                                          <div className='item_plus'>
                                            <div className='image_plus'>
                                              <img src={Plus} alt="avatar plus restaurant" />
                                            </div>
                                            <div className='value_plus'>
                                              <span>{item.libelle}</span>
                                            </div>
                                          </div>
                                        </div>
                                      )
                                    })
                                    : ''}
                                  {regime?.length !== 0 ?
                                    regime?.map((item, index) => {
                                      return (
                                        <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6' key={index}>
                                          <div className='item_plus'>
                                            <div className='image_plus'>
                                              <img src={Plus} alt="avatar plus restaurant" />
                                            </div>
                                            <div className='value_plus'>
                                              <span>{item.libelle}</span>
                                            </div>
                                          </div>
                                        </div>
                                      )
                                    })
                                    : ''}


                                </div>
                              </div>

                            </div>
                          </div>
                          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div className='payement_restaurant'>
                              <div className='payement_restaurantContent'>
                                <div className='titre_payement'>
                                  <span><i className='fa fa-money'></i> Mode de payement acceptés</span>
                                </div>
                              </div>
                              <div className='payement_content'>
                                <div className='row'>
                                  {payement?.length !== 0 ?
                                    payement?.map((item, index) => {
                                      return (<div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6' key={index}>
                                        <div className='item_payement'>
                                          <div className='image_payement'>
                                            <img src={Money} alt="avatar plus restaurant" />
                                          </div>
                                          <div className='value_payement'>
                                            <span>{item.libelle}</span>
                                          </div>
                                        </div>
                                      </div>)
                                    })

                                    : ''}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                            <div className='resto_map'>
                              <div className='resto_map_titre'>
                                <h4> <i className='fa fa-map-marker'></i>Localisation – Plan / adresse</h4>
                              </div>

                              <div className="resto_map_content">
                                <h5>Adresse</h5>
                                <PhotoProvider>
                                  <p>{restaurant.adresse} : {restaurant.precision}</p>
                                  {planUrl !== null ?
                                    <div className='resto_map_image'>
                                      <PhotoView src={BASE_URL + planUrl}>
                                        <img src={BASE_URL + planUrl} alt="avatar map" />
                                      </PhotoView>
                                    </div>
                                    : ''}
                                </PhotoProvider>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>






                  {restaurant?.photoRestos.length !== 0 ?
                    <div className="resto_photo_telecharger">
                      <div className='resto_photo_telecharger_titre'>
                        <h4> <i className='fa fa-photo'></i>Photo des clients</h4>
                      </div>
                      <div className='row'>
                        <PhotoProvider>
                          {restaurant?.photoRestos.map((element, index) => {
                            return (
                              <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3' key={index}>
                                <div className='resto_photo_img'>
                                  <PhotoView src={BASE_URL + element.photoUrl}>
                                    <img src={BASE_URL + element.photoUrl} alt="telecharger client" />
                                  </PhotoView>
                                </div>
                              </div>)
                          })}
                        </PhotoProvider>

                      </div>
                    </div>
                    : ""}






                </div>
                <Modal
                  show={show}
                  size="lg"
                  aria-labelledby="contained-modal-title-vcenter"
                  centered

                  onHide={handleCloseDetailMenu}
                >
                  <Modal.Body className="shadow">
                    <div className='modal_detail_menu'>
                      <div className='header_detail_menu'>
                        <h5>{elementMenu.nomMenu} à <span>{elementMenu.prixMenu} Ar</span></h5>
                        <span className='close' onClick={handleCloseDetailMenu}><i className='fa fa-close'></i></span>
                      </div>
                      <div className='content_detail_menu'>
                        <div className='content_detail_description'>
                          <h6>Ce menu comprend:</h6>
                          <div className='content_detail_liste mt-2'>
                            {elementMenu.platMenu !== "" && elementMenu.avecContenus?.length !== 0 ?
                              <><span className='detail_liste'>{elementMenu.platMenu}</span>
                                <span className='detail_plus'>+</span></> :
                              elementMenu.platMenu !== "" && elementMenu.avecContenus?.length === 0 ?
                                <span className='detail_liste'>{elementMenu.platMenu}</span>
                                : ""
                            }

                            {elementMenu.autrePlatMenu !== "" && elementMenu.avecContenus?.length !== 0 ?
                              <><span className='detail_liste'>{elementMenu.autrePlatMenu}</span> <span className='detail_plus'>+</span></> :
                              elementMenu.autrePlatMenu !== "" && elementMenu.avecContenus?.length === 0 ?
                                <span className='detail_liste'>{elementMenu.autrePlatMenu}</span> : ''}


                            {elementMenu.avecContenus?.length !== 0 ?
                              elementMenu.avecContenus?.map((elAvec, iAvec) => {
                                if (iAvec === elementMenu.avecContenus?.length - 1) {
                                  return (<span className='detail_liste' key={iAvec}>{elAvec.libelle}</span>);
                                } else {

                                  return (<div key={iAvec} ><span className='detail_liste'>{elAvec.libelle}</span><span className='detail_plus'>+</span></div>);
                                }

                              })
                              : ''}
                          </div>
                          <h6>Ce menu disponible:</h6>
                          <div className='content_detail_liste mt-2'>

                            {elementMenu.moments?.length !== 0 ?
                              elementMenu.moments?.map((elMoment, iMoment) => {
                                return (
                                  <span className='detail_liste_disponible' key={iMoment}>{elMoment.libelle}</span>
                                );
                              }) : ""}



                          </div>
                          <div className='content_detail_liste mt-3'>
                            <span className='me-2' >Le</span>
                            {elementMenu.jours?.length !== 0 ?
                              elementMenu.jours?.map((elJour, iJour) => {
                                return (<span className='detail_liste_disponible' key={iJour}>{elJour.libelle}</span>);
                              })
                              : ''}
                          </div>
                        </div>
                        <div className='row'>
                          {elementMenu.entrerMenus?.length !== 0 ?
                            <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                              <div className='content_detail_item'>
                                <div className='content_detail_itemTitre'>
                                  <h6 className='text-center'>Entrée</h6>

                                </div>
                                <div className='content_detail_itemListe'>
                                  {elementMenu.entrerMenus?.map((elEntrer, iEntrer) => {
                                    if (iEntrer === elementMenu.entrerMenus?.length - 1) {
                                      return (<span key={iEntrer}>{elEntrer.libelle}</span>);
                                    } else {

                                      return (<><span key={iEntrer}>{elEntrer.libelle}</span>
                                        <hr /></>);
                                    }

                                  })}


                                </div>
                              </div>
                            </div>
                            : ''}


                          {elementMenu.platMenus?.length !== 0 ?
                            <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                              <div className='content_detail_item'>
                                <div className='content_detail_itemTitre'>
                                  <h6 className='text-center'>Plats</h6>

                                </div>
                                <div className='content_detail_itemListe'>
                                  {elementMenu.platMenus?.map((elPlat, iPlat) => {
                                    if (iPlat === elementMenu.platMenus?.length - 1) {
                                      return (<span key={iPlat}>{elPlat.libelle}</span>);
                                    } else {

                                      return (<><span key={iPlat}>{elPlat.libelle}</span>
                                        <hr /></>)
                                    }
                                  })}


                                </div>
                              </div>
                            </div>
                            : ''}


                          {elementMenu.dessertMenus?.length !== 0 ?
                            <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                              <div className='content_detail_item'>
                                <div className='content_detail_itemTitre'>
                                  <h6 className='text-center'>Dessert</h6>

                                </div>
                                <div className='content_detail_itemListe'>
                                  {elementMenu.dessertMenus?.map((elDessert, iDessert) => {
                                    if (iDessert === elementMenu.dessertMenus?.length - 1) {
                                      return (<span key={iDessert}>{elDessert.libelle}</span>);
                                    } else {
                                      return (<><span key={iDessert}>{elDessert.libelle}</span>
                                        <hr /></>)
                                    }
                                  })}

                                </div>
                              </div>
                            </div>
                            : ''}
                          {elementMenu.autreMenus?.length !== 0 ?
                            <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                              <div className='content_detail_item'>
                                <div className='content_detail_itemTitre'>
                                  <h6 className='text-center'>{elementMenu.nomAutre}</h6>

                                </div>
                                <div className='content_detail_itemListe'>
                                  {elementMenu.autreMenus?.map((elAutre, iAutre) => {
                                    if (iAutre === elementMenu.autreMenus?.length - 1) {
                                      return (<span key={iAutre}>{elAutre.libelle}</span>);
                                    } else {
                                      return (<><span key={iAutre}>{elAutre.libelle}</span>
                                        <hr /></>)
                                    }
                                  })}

                                </div>
                              </div>
                            </div>
                            : ''}

                        </div>
                        <p className='mt-3'>
                          {elementMenu.introduire}
                        </p>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>


                <Modal
                  show={showSpecial}
                  size="lg"
                  aria-labelledby="contained-modal-title-vcenter"
                  centered

                  onHide={handleCloseDetailSpecial}
                >
                  <Modal.Body className="shadow">
                    <div className='modal_detail_menu'>
                      <div className='header_detail_menu'>
                        <h5>{promoSpecial[0]?.libelle} à <span>{promoSpecial[0]?.prix} Ar</span></h5>
                        <span className='close' onClick={handleCloseDetailSpecial}><i className='fa fa-close'></i></span>
                      </div>
                      <div className='content_detail_menu'>
                        <div className='content_detail_description'>
                          <h6>Ce menu comprend:</h6>
                          <div className='content_detail_liste mt-2'>

                            <span className='detail_liste'>{promoSpecial[0]?.platMenu !== "" ? promoSpecial[0]?.platMenu : promoSpecial[0]?.autrePlatMenu}</span>

                            {promoSpecial[0]?.avecContenuSpecials?.length !== 0 ?
                              <>
                                <span className='detail_plus'>+</span>
                                {promoSpecial[0]?.avecContenuSpecials?.map((elAvec, iAvec) => {
                                  if (iAvec === promoSpecial[0]?.avecContenuSpecials?.length - 1) {
                                    return (<span className='detail_liste' key={iAvec}>{elAvec.libelle}</span>);
                                  } else {
                                    return (<div key={iAvec} ><span className='detail_liste'>{elAvec.libelle}</span><span className='detail_plus'>+</span></div>);
                                  }

                                })}
                              </>
                              : ''}
                          </div>

                        </div>
                        <div className='row'>
                          {promoSpecial[0]?.entrerSpecials?.length !== 0 ?
                            <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                              <div className='content_detail_item'>
                                <div className='content_detail_itemTitre'>
                                  <h6 className='text-center'>Entrée</h6>

                                </div>
                                <div className='content_detail_itemListe'>
                                  {promoSpecial[0]?.entrerSpecials?.map((elEntrer, iEntrer) => {
                                    if (iEntrer === promoSpecial[0]?.entrerSpecials?.length - 1) {
                                      return (<span key={iEntrer}>{elEntrer.libelle}</span>);
                                    } else {

                                      return (<><span key={iEntrer}>{elEntrer.libelle}</span>
                                        <hr /></>);
                                    }

                                  })}


                                </div>
                              </div>
                            </div>
                            : ''}


                          {promoSpecial[0]?.platSpecials?.length !== 0 ?
                            <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                              <div className='content_detail_item'>
                                <div className='content_detail_itemTitre'>
                                  <h6 className='text-center'>Plats</h6>

                                </div>
                                <div className='content_detail_itemListe'>
                                  {promoSpecial[0]?.platSpecials?.map((elPlat, iPlat) => {
                                    if (iPlat === promoSpecial[0]?.platSpecials?.length - 1) {
                                      return (<span key={iPlat}>{elPlat.libelle}</span>);
                                    } else {

                                      return (<><span key={iPlat}>{elPlat.libelle}</span>
                                        <hr /></>)
                                    }
                                  })}


                                </div>
                              </div>
                            </div>
                            : ''}


                          {promoSpecial[0]?.dessertSpecials?.length !== 0 ?
                            <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                              <div className='content_detail_item'>
                                <div className='content_detail_itemTitre'>
                                  <h6 className='text-center'>Dessert</h6>

                                </div>
                                <div className='content_detail_itemListe'>
                                  {promoSpecial[0]?.dessertSpecials?.map((elDessert, iDessert) => {
                                    if (iDessert === promoSpecial?.dessertSpecials?.length - 1) {
                                      return (<span key={iDessert}>{elDessert.libelle}</span>);
                                    } else {
                                      return (<><span key={iDessert}>{elDessert.libelle}</span>
                                        <hr /></>)
                                    }
                                  })}

                                </div>
                              </div>
                            </div>
                            : ''}
                          {promoSpecial[0]?.autreSpecials?.length !== 0 ?
                            <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                              <div className='content_detail_item'>
                                <div className='content_detail_itemTitre'>
                                  <h6 className='text-center'>{promoSpecial[0]?.nomAutre}</h6>

                                </div>
                                <div className='content_detail_itemListe'>
                                  {promoSpecial[0]?.autreSpecials?.map((elAutre, iAutre) => {
                                    if (iAutre === promoSpecial[0]?.autreSpecials?.length - 1) {
                                      return (<span key={iAutre}>{elAutre.libelle}</span>);
                                    } else {
                                      return (<><span key={iAutre}>{elAutre.libelle}</span>
                                        <hr /></>)
                                    }
                                  })}

                                </div>
                              </div>
                            </div>
                            : ''}

                        </div>
                        <p className='mt-3'>
                          {promoSpecial[0]?.introduire}
                        </p>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>

              </div>


            </div>
          </Modal.Body>
        </Modal>

      </div>
    </div >
  )
}

export default CarteMenu